import { render } from "./RankingBrowser.vue?vue&type=template&id=ca35121c"
import script from "./RankingBrowser.vue?vue&type=script&lang=js"
export * from "./RankingBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__